import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalsService } from '../libs/globals.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  server = GlobalsService.server;
  url = this.server + 'api/usuarios';
  constructor(private http:HttpClient) { }

  getUsuarios(): Observable<any> {
    return this.http.get(this.url);
  }
}
